// Apollo
import messageCreatedGql from "@/Apollo/subscriptions/chat/messageCreated.graphql";
import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { SubscriptionHookOptions, useSubscription } from "@apollo/client";
import {
  MessageCreatedSubscription,
  MessageCreatedSubscriptionVariables,
} from "@whoppah/apollo/schema";

/**
 * Hook for subscribing to the `message created` event.
 * @param options - Hook typing options.
 * @returns Subscription results.
 */
export const useMessageCreatedSubscription = (
  options?: SubscriptionHookOptions<
    MessageCreatedSubscription,
    MessageCreatedSubscriptionVariables
  >
) => {
  const currency = useDisplayCurrency();

  return useSubscription(messageCreatedGql, {
    ...withDisplayCurrency(options, currency),
    skip: typeof window === "undefined",
  });
};
